import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles({
  positionProgress: {
    display: "flex",
    alignItems: "center",
    gap: "4px",
  },
  positionStable: {
    color: "#6B7280",
  },
  positionUp: {
    color: "#059669",
  },
  positionDown: {
    color: "#DC2626",
  },
  progressIcon: {
    width: "16px",
    height: "16px",
  },
});
